<template>
	<div
		class="reserve-background-width"
		style="max-width: 1440px !important; width:1440px; min-width:1440px; height:2503px; min-height:2503px; max-height:2503px; overflow:auto;"
	>
		<div v-if="step === '1'">
			<v-img
				v-if="eventsData.eventImg"
				:src="direct_img ? direct_img : $store.state.frontServer_upload + eventsData.eventImg.url"
				@error="imgError()"
				class="imageButton"
				contain
				@click="startEvent()"
			>
			</v-img>
			<v-img v-else :src="defaultImg" class="imageButton" @click="startEvent()"> </v-img>
		</div>
		<div v-show="step === '2'">
			<main class="content_step2">
				<section class="info-section">
					<section class="info-header"><span class="mr-2">|</span> 기본 정보 입력 <span class="ml-2">|</span></section>
					<div class="info-form">
						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">이 름</label>
								<v-flex xs12>
									<input
										type="text"
										class="form-input-direct"
										v-model="nametxtField.value"
										@input="disableNext()"
										placeholder="이름을 입력하세요"
									/>
								</v-flex>
							</v-layout>
						</div>

						<div class="form-group">
							<v-layout align-center>
								<label class="form-label">전화번호</label>
								<v-layout wrap>
									<v-flex xs2>
										<select-box :sel="numSel" @change="change"></select-box>
									</v-flex>
									<v-flex xs10 class="pl-1">
										<input type="tel" class="form-input-direct" v-model="numtxtField.value" placeholder="번호를 입력하세요" maxlength="8" />
									</v-flex>
								</v-layout>
							</v-layout>
						</div>
					</div>
				</section>
				<section class="info-desc">
					<div class="next-button-container">
						<button class="action-button-outlined mr-4" @click="step = '1'">이전으로</button>
						<div class="nextButton_css" @click="submitForm">
							<span class="text">다음으로</span>
							<span class="arrow">&#8250;</span>
						</div>
					</div>
					<div class="consent-container">
						<div class="consent-title">■ 개인정보 수집/이용 및 마케팅 활용에 관한 동의</div>

						<table class="consent-info-table">
							<colgroup>
								<col style="width: 20%" />
								<col style="width: 40%" />
								<col style="width: 16%" />
								<col style="width: 24%" />
							</colgroup>
							<tbody>
								<tr>
									<td class="td-label">개인정보의 수집주체</td>
									<td class="td-content">시행·시공 : ㈜아이에스동서</td>
									<th class="td-label">개인정보 위탁업체</th>
									<td class="td-content">대영레데코㈜</td>
								</tr>
								<tr>
									<td class="td-label">수집하는 개인정보의<br />목적 및 항목</td>
									<td class="td-content" colspan="3">
										1) 수집목적 : 「펜타힐즈 W」의 분양정보 및 마케팅 활용(모바일 또는 유선전화를 통해 음성 및 문자안내)<br />
										2) 수집항목 : 성명, 성별, 연락처, 연령대, 주소, 설문내용
									</td>
								</tr>
								<tr>
									<td class="td-label">개인정보의<br />처리 및 보유기간</td>
									<td class="td-content" colspan="3">
										1) 이용기간 : 정보수집일로부터 1년<br />
										2) 귀하는 개인정보에 대해 정정을 요구하거나 삭제를 요청할 수 있습니다.
									</td>
								</tr>
								<tr>
									<td class="td-label">거부할 권리</td>
									<td class="td-content" colspan="3">
										귀하께서는 개인정보 수집 및 이용을 거부하실 수 있습니다. 단, 이 경우 분양정보 안내 등의 서비스를 제공해 드릴 수
										없습니다.
									</td>
								</tr>
							</tbody>
						</table>

						<table class="consent-agree-table">
							<colgroup>
								<col style="width: 60%" />
								<col style="width: 20%" />
								<col style="width: 20%" />
							</colgroup>
							<tbody>
								<tr>
									<td class="agree-question">개인정보 수집 및 이용에 대해 동의하십니까?</td>
									<td class="agree-option">
										<label class="radio-label">
											<input type="radio" name="consent1" value="agree" v-model="personalInfoConsent" />
											동의함
										</label>
									</td>
									<td class="agree-option">
										<label class="radio-label">
											<input type="radio" name="consent1" value="disagree" v-model="personalInfoConsent" />
											동의하지 않음
										</label>
									</td>
								</tr>
								<tr>
									<td class="agree-question">「펜타힐즈 W」마케팅 활용에 대해 동의하십니까?</td>
									<td class="agree-option">
										<label class="radio-label">
											<input type="radio" name="consent2" value="agree" v-model="marketingConsent" />
											동의함
										</label>
									</td>
									<td class="agree-option">
										<label class="radio-label">
											<input type="radio" name="consent2" value="disagree" v-model="marketingConsent" />
											동의하지 않음
										</label>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</section>
			</main>
		</div>
		<div v-show="step === '3'">
			<v-img src="@/assets/images/event_back_1.jpg">
				<main class="content_step3">
					<section class="info-header"><span class="mr-2">|</span> 인증번호 입력 <span class="ml-2">|</span></section>
					<div class="auth-header">
						<p class="bold">알림톡으로 전송된 본인 인증번호를 입력해주세요.</p>
						<p>(알림톡 발송에는 약 10초~20초 소요됩니다.)</p>
					</div>

					<div class="auth-form">
						<div class="auth-input-container">
							<input type="text" id="auth-input" v-model="authCode" readonly />
						</div>

						<div class="keypad">
							<div class="keypad-row">
								<button class="key number-key" @click="addNumber('1')">1</button>
								<button class="key number-key" @click="addNumber('2')">2</button>
								<button class="key number-key" @click="addNumber('3')">3</button>
							</div>
							<div class="keypad-row">
								<button class="key number-key" @click="addNumber('4')">4</button>
								<button class="key number-key" @click="addNumber('5')">5</button>
								<button class="key number-key" @click="addNumber('6')">6</button>
							</div>
							<div class="keypad-row">
								<button class="key number-key" @click="addNumber('7')">7</button>
								<button class="key number-key" @click="addNumber('8')">8</button>
								<button class="key number-key" @click="addNumber('9')">9</button>
							</div>
							<div class="keypad-row">
								<button class="key clear-key" @click="clearAll()">전체<br />지움</button>
								<button class="key number-key" @click="addNumber('0')">0</button>
								<button class="key backspace-key" @click="backspace()">←</button>
							</div>
						</div>
					</div>
					<div class="action-button-container">
						<button class="action-button-outlined mr-4" @click="step = '2'">이전으로</button>
						<div class="nextButton_css" @click="submitAuthCode()">
							<span class="text">입력완료</span>
							<span class="arrow">&#8250;</span>
						</div>
					</div>
				</main>
			</v-img>
		</div>
		<!-- <main class="content_step4" v-show="step === '4'">
			<v-img src="@/assets/images/content_5_header_theway.jpg" class="imageButton">
				<v-layout class="clickBtn" wrap justify-center style="bottom: 640px !important;">
					<button @click="startEvent()" class="nextButton_css" style="width: 500px!important;">
						<span class="text">응모권 출력</span>
						<span class="arrow">&#8250;</span>
					</button>
				</v-layout>
			</v-img>
		</main> -->
		<v-dialog v-model="roulletDialog" overlay-opacity="0.9" eager persistent content-class="roullet_dialog">
			<div class="roullet_div">
				<img class="roullet_arrow" src="@/assets/images/roullet_arrow.png" />
				<img class="roullet_board" ref="roullet_board" src="@/assets/images/hills_roullet2.png" />
			</div>
		</v-dialog>

		<v-dialog v-model="lucky" persistent content-class="check_dialog check_dialog_tablet">
			<img :src="luckyImage" class="lucky-image" />
			<v-btn :color="btnColor" x-large @click="closeLucky()" block style="font-size: 42px;" height="80">
				확인
			</v-btn>
		</v-dialog>
		<div id="print-background-cobe">
			<div
				style="display: flex; justify-content: center; align-items: center; background-color: #f5f5f5; margin: 0; padding: 0; font-family: 'Noto Sans KR', Arial, sans-serif;"
			>
				<div
					style="width: 100%; height: auto; background-color: white; overflow: hidden; text-align: center; padding: 12px 5px; display: flex; flex-direction: column;"
				>
					<div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">서수원 에피트</div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">센트럴마크</div>
					</div>

					<div style="border-radius: 10px; margin: 0 4px; padding: 4px;">
						<div style="text-align: center; font-weight: bold; font-size: 20px; line-height: 24px; margin-bottom:4px;">
							{{ nametxtField.value }} 고객님
						</div>
						<div style="text-align: center; font-weight: bold; font-size: 20px; line-height: 24px; margin-bottom: 4px;">
							{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
						</div>
						<div style="text-align: center; font-size: 20px; margin-bottom: 4px; margin-top: 4px; font-weight: bold; line-height: 24px;">
							({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
						</div>
					</div>
					<div style="margin-top: 10px; margin-bottom: 10px; text-align: left;">
						<div style="font-size: 9px; font-weight: bold; color: #777;">※ 제세공과금 22%는 당첨자 본인이 부담 하셔야합니다.</div>
						<div style="font-size: 9px; font-weight: bold; color: #777;">
							※ 경품추첨시 견본주택 내 계신분에 한해 당첨이 인정되며, <br />
							<span style="margin-left: 12px;">
								없을 시 무효처리후 재추첨 합니다.
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="print-background-cobe2">
			<div
				style="display: flex; justify-content: center; align-items: center; background-color: #f5f5f5; margin: 0; padding: 0; font-family: 'Noto Sans KR', Arial, sans-serif;"
			>
				<div
					style="width: 100%; height: auto; background-color: white; overflow: hidden; text-align: center; padding: 12px 5px; display: flex; flex-direction: column;"
				>
					<div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">(보관용)</div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">서수원 에피트</div>
						<div style="font-size: 24px; font-weight: bold; color: #000;">센트럴마크</div>
					</div>
					<div style="border-radius: 10px; margin: 0 4px; padding: 4px;">
						<div style="text-align: center; font-weight: bold; font-size: 20px; line-height: 24px; margin-bottom:4px;">
							{{ nametxtField.value }} 고객님
						</div>
						<div style="text-align: center; font-weight: bold; font-size: 20px; line-height: 24px; margin-bottom: 4px;">
							{{ numSel.value }}-{{ phoneCrypto(numtxtField.value) }}
						</div>
						<div style="text-align: center; font-size: 20px; margin-bottom: 4px; margin-top: 4px; font-weight: bold; line-height: 24px;">
							({{ new Date() | moment('YYYY-MM-DD HH:mm') }})
						</div>
					</div>
					<div style="margin-top: 10px; margin-bottom: 10px; text-align: left;">
						<div style="font-size: 9px; font-weight: bold; color: #777;">※ 제세공과금 22%는 당첨자 본인이 부담 하셔야합니다.</div>
						<div style="font-size: 9px; font-weight: bold; color: #777;">
							※ 경품추첨시 견본주택 내 계신분에 한해 당첨이 인정되며, <br />
							<span style="margin-left: 12px;">
								없을 시 무효처리후 재추첨 합니다.
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal5, selectBox, txtField } from '@/components/index.js'
import Hangul from 'hangul-js'
export default {
	components: {
		txtField,
		selectBox,
		alertModal5,
	},
	metaInfo() {
		return {
			// 페이지 제목 캠페인 명에 따라 변경
			title: this.campaignTitle,
		}
	},
	data() {
		return {
			messageData3: {},
			// 오늘 대기 번호
			waitNum: '',
			/// 대기자 수
			waitLength: '',
			printType: 0,
			agree: true,
			waiting_agree: 'agree',
			personalInfoConsent: 'agree',
			marketingConsent: 'agree',
			alertModal: {
				dialog: false,
				text: '이름과 전화번호를 입력해 주세요.',
			},
			numtxtField: {
				height: 50,
				color: 'white',
				label: '전화번호를 입력하세요',
				solo: true,
				dark: false,
				type: 'Number',
				value: '',
				onlyNumber: true,
				maxlength: 8,
				maxNumber: true,
				max: 99999999,
				readonly: false,
			},
			nametxtField: {
				height: 50,
				value: '',
				solo: true,
				readonly: false,
				label: '이름을 입력하세요',
				dark: false,
				color: 'white',
			},
			numSel: {
				value: '010',
				solo: true,
				class: 'selectNum',
				items: ['010', '011', '016', '017'],
				dark: false,
				color: 'white',
				height: 80,
				fontSize: 36,
			},
			authCode: '',
			step: '1',
			scheduleData: [
				{ type: '특별공급', date: '4.28', day: '월' },
				{ type: '1순위', date: '4.29', day: '화' },
				{ type: '2순위', date: '4.30', day: '수' },
			],
			houseInfo: [{ size: '84m²' }, { size: '101m²' }, { size: '108m²' }],
			totalUnits: 307,
			contactNumber: '1600.0255',

			footnotes: [
				'당첨 후 경품 수령시 성명, 연락처가 일치하여야만 경품 수령이 가능합니다.',
				'상기 경품 이미지는 실제와 다를 수 있습니다.',
				'해당 이벤트는 사은품 소진 수량 소진시 이벤트가 종료될 수 있습니다.',
				'경품 제세공과금(22%)은 소비자부담입니다.',
			],
			nameTxtArray: [],
			companyInfo: {
				name: '	㈜프런티어마루',
				purpose: '1) 수집목적: 서수원 에피트 분양정보에 대한 안내(전화, 문자, 우편), 이벤트 응모\n2) 수집항목 : 성명 및 연락처',
				usage: '	서수원 에피트 분양완료시까지',
				retention:
					'회사는 상기 고객 서비스 제공을 위하여 필요시 아래와 같은 외부 전문업체에 전산 업무를 위탁하여 운영하고 있습니다.\n- 수탁업체 : 분양대행사 ㈜프런티어마루\n위탁업무의 내용',
				rights:
					'귀하께서는 개인정보 수집/이용을 거절하실 수 있으며, 거절하실 경우 분양 정보 안내 등의 서비스 제공이 불가하며 \n 방문고객 경품 이벤트에 참여하실 수 없습니다.',
			},
			eventsData: { eventImg: null },
			code: '',
			winnterProduct: '',
			btnColor: '',
			lucky: false,
			luckyImage: '',
			roulletDialog: false,
			check_dialog: false,
			keypadInput: false,
			keyboardData: '',
			defaultImg: require('@/../public/image/default_main.png'),
			placeTitle: '',
			nextbtn: {
				block: true,
				large: true,
				class: 'customBtn2',
				color: this.$store.state.PointColor7,
			},
			backbtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reserveDialog: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			reserveDialog1: {
				title: '예약정보',
				dialog: false,
				step1: true,
				step2: false,
				step3: false,
				name: '',
				inputUserData: {
					name: '',
					phone: '',
				},
			},
			startDialog: {
				step1: true,
				dialog: false,
				nametxtField: {
					value: '',
					outlined: true,
					placeholder: '성명을 입력하세요.',
					color: 'black',
				},
				numSel: {
					value: '010',
					outlined: true,
					class: 'selectNum',
					items: ['010', '011', '016', '017'],
					color: 'black',
				},
				numtxtField: {
					value: '',
					outlined: true,
					placeholder: '숫자만 입력하세요',
					onlyNumber: true,
					maxlength: 8,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
				phonetxtField: {
					value: '',
					outlined: true,
					placeholder: '문자로 전송된 인증번호를 입력하세요',
					onlyNumber: true,
					maxlength: 6,
					color: 'black',
					max: 99999999,
					type: 'Number',
				},
			},
			trackingCodes: [],
			alertModal2: {
				dialog: false,
				text: '',
			},
			noInputBox: false,
			campaignTitle: '',
			surveyLegnth: 0,
			agreeContent: '',
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData4: {}, // 내가받을 알림톡 알림톡 데이터
			direct_img: null,
		}
	},

	async created() {
		// Check if route parameter is cobeplan and set appropriate code based on Korean date
		if (this.$route.params.code === 'cobe13') {
			const today = this.$moment() // Korean timezone
			const day = today.date()
			const month = today.month() + 1 // moment months are 0-indexed
			console.log(month, day, today.hours())

			if (month === 12 && day === 6) {
				this.direct_img = require('@/assets/images/event_main_img_chagne.jpg')
			}
			this.code = this.$route.params.code
		} else {
			this.code = this.$route.params.code
		}
		await this.reservedays()
		await this.events()
	},
	methods: {
		async reservedays() {
			const data = {
				code: 'cobe_waiting',
			}
			await this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.$store.state.reservedayData = JSON.parse(JSON.stringify(res.data.reservedays[0]))
				})
				.catch(() => {})
		},
		async createWaiting() {
			const datas = {
				inputBoxTitle: this.eventsData.input_box.name,
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,

				code: 'cobe_waiting',
				ismarketing: 2,
				ispersonal: 1,
				cdate: this.$moment(new Date()).add(9, 'hour'),
				date: this.$moment(new Date()).add(9, 'hour'),
				stat: 0,
				rdate: this.$moment(new Date()).add(9, 'hour'),
				title: this.eventsData.title,
				seat: 0, // 상담석으로 가기전의 대기 상태 부여 => seat = 0
				business: Number(this.eventsData.business.id),
				marketing: false,
			}
			await this.$store
				.dispatch('createWaiting', datas)
				.then(resWaiting => {
					this.$store
						.dispatch('waitings', { id: resWaiting.data.createWaiting.waiting.id, code: resWaiting.data.createWaiting.waiting.code })
						.then(res => {
							this.waitNum = res.data.waitings[0].waitingnum
							this.$store
								.dispatch('waitingsConnection', {
									code: 'cobe_waiting',
									// stat: 0,
									seat: 0,
									csdate: this.$moment().format('YYYY-MM-DD') + 'T00:00:00.000Z',
									cedate:
										this.$moment()
											.add(1, 'days')
											.format('YYYY-MM-DD') + 'T00:00:00.000Z',
									stat: 0,
								})
								.then(res => {
									const waitingsPeople = res.data.waitingsConnection.aggregate.count
									this.waitLength = waitingsPeople - 1
									this.$store.state.loading = false
									this.$store.dispatch('messages', {}).then(res => {
										let foundIndex3 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[3]
										})
										if (foundIndex3 !== -1) {
											this.messageData3 = res.data.messages[foundIndex3] // delete 알림톡 데이터
										}

										// this.sendMessageForDirect(resWaiting.data.createWaiting.waiting)
									})
								})
						})

					// this.$socket.emit('reservation', { code: datas.code })
					// this.$socket.emit('reservationBoardList', { code: datas.code })
				})
				.catch(() => {
					alert('일시적인오류가 발생하였습니다. 새로고침 후 다시 신청해 주세요.')
					this.$store.state.loading = false
				})
		},
		sendMessageForDirect(userdata) {
			const rdate = this.$moment(userdata.rdate)
				.subtract('hours', 9)
				.format('YYYY년 MM월 DD일 HH:mm')
			// let url = `${location.protocol}//${location.hostname}/waitingCheck/${this.code}/${userdata.phone}`
			let url = `${location.protocol}//${location.hostname}/waitingCheck/cobe_waiting/${userdata.phone}`
			// 청라 푸르지오 현장만 대기번호 자리에 사업지명(title)을 치환, 그 외 현장은 기존 동작(this.waitNum) 유지
			const waitNumValue =
				this.$store.state.reservedayData.title && this.$store.state.reservedayData.title.includes('청라 푸르지오')
					? this.$store.state.reservedayData.title + this.waitNum
					: this.waitNum
			if (this.messageData3.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				try {
					const parsedMessage = JSON.parse(this.messageData3.message)
					if (typeof parsedMessage === 'object' && parsedMessage !== null) {
						const replacedMessage = {}
						for (const [key, value] of Object.entries(parsedMessage)) {
							let replacedValue = value
							// 모든 값에서 플레이스홀더를 실제 데이터로 교체
							replacedValue = replacedValue.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
							replacedValue = replacedValue.replace(/#{고객명}/g, userdata.name)
							replacedValue = replacedValue.replace(/#{상담신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{상담 신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{관람신청일시}/g, rdate)
							replacedValue = replacedValue.replace(/#{대기번호}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기번호1}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기번호2}/g, waitNumValue)
							replacedValue = replacedValue.replace(/#{대기자수}/g, this.waitLength)
							replacedValue = replacedValue.replace(/#{대기정보}/g, url)
							replacedValue = replacedValue.replace(/#{그룹}/g, 'cobe_waiting')
							replacedValue = replacedValue.replace(/#{코드}/g, 'cobe_waiting')
							replacedValue = replacedValue.replace(/#{전화번호}/g, userdata.phone)
							replacedValue = replacedValue.replace(/#{상담ID}/g, userdata.phone)
							replacedValue = replacedValue.replace(/#{방문ID}/g, userdata.phone)
							replacedMessage[key] = replacedValue
						}
						this.messageData3.message = JSON.stringify(replacedMessage)
					}
				} catch (error) {
					console.error('JSON 파싱 오류:', error)
					// 파싱 실패 시 기존 방식 사용
					this.messageData3.message = this.messageData3.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
					this.messageData3.message = this.messageData3.message.replace(/#{고객명}/g, userdata.name)
					this.messageData3.message = this.messageData3.message.replace(/#{상담신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{상담 신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{관람신청일시}/g, rdate)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호1}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기번호2}/g, waitNumValue)
					this.messageData3.message = this.messageData3.message.replace(/#{대기자수}/g, this.waitLength)
					this.messageData3.message = this.messageData3.message.replace(/#{대기정보}/g, url)
					this.messageData3.message = this.messageData3.message.replace(/#{그룹}/g, 'cobe_waiting')
					this.messageData3.message = this.messageData3.message.replace(/#{코드}/g, 'cobe_waiting')
					this.messageData3.message = this.messageData3.message.replace(/#{전화번호}/g, userdata.phone)
				}
			}
			if (this.messageData3.button) {
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData3.button = this.messageData3.button.replace(/#{고객명}/g, userdata.name)
				this.messageData3.button = this.messageData3.button.replace(/#{상담신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{상담 신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{관람신청일시}/g, rdate)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호1}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기번호2}/g, waitNumValue)
				this.messageData3.button = this.messageData3.button.replace(/#{대기자수}/g, this.waitLength)
				this.messageData3.button = this.messageData3.button.replace(/#{대기정보}/g, url)
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{그룹}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{코드}/g, 'cobe_waiting')
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{전화번호}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{상담ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{상담ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{방문ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(/#{방문ID}/g, userdata.phone)
				this.messageData3.button = this.messageData3.button.replace(
					/#{분양정보pdf}/g,
					this.eventsData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				this.messageData3.button = this.messageData3.button.replace(
					/#{분양정보pdf}/g,
					this.eventsData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
				)
				if (this.eventsData.business.alertTalkSubscriptionInformation?.url) {
					this.messageData3.button = this.messageData3.button.replace(
						/#{청약안내pdf}/g,
						this.eventsData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
					this.messageData3.button = this.messageData3.button.replace(
						/#{청약안내pdf}/g,
						this.eventsData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
					)
				}
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.eventsData.business.alertTalkTalk)
				this.messageData3.button = this.messageData3.button.replace(/#{사업지명}/g, this.eventsData.business.alertTalkTalk)
				this.messageData3.button = this.messageData3.button.replace(/#{url}/g, this.eventsData.business.alertTalkHomepage)
				this.messageData3.button = this.messageData3.button.replace(/#{url}/g, this.eventsData.business.alertTalkHomepage)
			}
			const data = {
				// 필수값

				code: 'cobe_waiting',
				sender: this.messageData3.smssender,
				senderkey: this.messageData3.senderkey,
				tpl_code: this.messageData3.tplCode,
				receiver_1: userdata.phone,
				subject_1: this.messageData3.tplCodeStr,
				message_1: this.messageData3.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: userdata.name,
				failover: 'Y',
				fsubject_1: this.messageData3.tplCodeStr,
				fmessage_1: this.messageData3.button,
				pay: this.eventsData.business?.id,
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(err => {
					console.log(err)
				})
		},
		setAgree(val) {
			this.agree = val
		},
		async eventJoins() {
			this.$store
				.dispatch('eventJoins', {
					code_in: [this.code],
					phone: String(this.numSel.value + this.numtxtField.value),
					// sdate:
					// 	this.$moment()
					// 		.subtract(1, 'd')
					// 		.format('YYYY-MM-DD') + ' 15:00:00',
					// edate: this.$moment().format('YYYY-MM-DD') + ' 15:00:00',
				})
				.then(res => {
					if (res.data.eventJoins.length > 0) {
						this.alertModal.text = '이미 응모하신 번호입니다.'
						this.$store.state.loading = false
						this.step = '1'
						this.numtxtField.value = ''
						this.nametxtField.value = ''
						this.nameTxtArray = []
						return (this.alertModal.dialog = true)
					} else this.startEvent()
				})
		},
		async authCodecheck() {
			const data = {
				receiver: this.numSel.value + this.numtxtField.value,
				// created_at_gte: this.$moment().format('YYYY-MM-DD') + 'T00:00:00.000Z',
				// created_at_lte:
				// 	this.$moment()
				// 		.add(1, 'd')
				// 		.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				authCode: String(this.authCode),
				limit: 1,
			}
			await this.$store.dispatch('sendSms', data).then(async res => {
				if (res.data.sendSms.length > 0) {
					await this.createEventJoin()
				} else {
					this.alertModal.dialog = true
					this.alertModal.text = '인증번호가 틀렸습니다.'
				}
			})
			// await this.$store.dispatch('sendMessages', data).then(res => {
			// 	if (res.data.sendMessages.length > 0) {
			// 		this.step = '4'
			// 	} else {
			// 		this.alertModal.dialog = true
			// 		this.alertModal.text = '인증번호가 틀렸습니다.'
			// 	}
			// })
		},
		phoneCrypto(data) {
			return data.replace(/\d(?=\d{4})/g, '*')
		},
		createSendSm() {
			var randomCode = Math.floor(Math.random() * 1000000) + 100000
			if (randomCode > 1000000) {
				randomCode = randomCode - 100000
			}
			var message = `[키오스크 이벤트 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`
			const data = {
				receiver: this.numSel.value + this.numtxtField.value,
				message: message,
				authCode: String(randomCode),
				sender: process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				pay: '29',
			}
			this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					alert('SMS 전송시 오류가 발생하였습니다. 다시 시도해 주세요.')
					console.log({ err })
				})
		},
		async createEventJoin() {
			this.$store.state.loading = true
			let data2 = {
				name: this.nametxtField.value,
				phone: this.numSel.value + this.numtxtField.value,
				code: this.code,
				marketing: this.marketingConsent === 'agree' ? true : false,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			await this.$store.dispatch('createEventJoin', data2).then(async res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal.dialog = true
					this.$store.state.loading = false
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal.dialog = true
					this.$store.state.loading = false
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)

					// if (this.waiting_agree === 'agree') {
					// 	await this.createWaiting()
					// }

					// 룰렛 돌리기
					this.spinRoullet()
				}
			})
		},
		async eventJoinsConnection() {
			await this.$store.dispatch('eventJoinsConnection', { code: this.code }).then(res => {
				if (this.eventsData.maxcount < res.data.eventJoinsConnection.aggregate.count) {
					this.alertModal.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			})
		},
		async events() {
			this.$store.state.loading = true
			const data = {
				code: this.code,
			}
			await this.$store
				.dispatch('events', data)
				.then(res => {
					if (res.data.events.length === 0) {
						this.$router.push({ name: 'notfound' })
					}
					this.eventsData = res.data.events[0]

					this.$store.state.loading = false
					this.eventJoinsConnection()
					if (this.eventsData.business) {
						this.nextbtn.color = this.eventsData.business.color
						this.btnColor = this.eventsData.business.color
					}
				})
				.catch(err => {
					console.log(err)
				})
		},
		change() {
			return {}
		},

		addNumber(number) {
			if (this.authCode.length < 6) this.authCode += String(number)
		},
		clearAll() {
			this.authCode = ''
		},
		backspace() {
			this.authCode = this.authCode.slice(0, -1)
		},
		submitAuthCode() {
			if (this.authCode.length > 0 && this.authCode.length < 7) {
				this.startEvent()
				// 여기에 실제 인증 로직 추가
			} else {
				this.alertModal.text = '인증번호 6자리를 입력해주세요.'
				this.alertModal.dialog = true
			}
		},
		async submitForm() {
			if (!this.nametxtField.value) {
				this.alertModal.text = '이름을 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (!this.numtxtField.value) {
				this.alertModal.text = '전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}

			if (this.personalInfoConsent !== 'agree') {
				this.alertModal.text = '개인정보 수집 및 이용동의 해주셔야 응모권 참여가 가능합니다.'
				return (this.alertModal.dialog = true)
			}

			if (this.numtxtField.value.length < 8) {
				this.alertModal.text = '최소 7자리의 올바른 전화번호를 입력해주세요.'
				return (this.alertModal.dialog = true)
			}
			if (this.numtxtField.value === '00000000') return (this.step = '4')
			if (this.eventsData.duplicate === false) await this.eventJoins()
			else this.startEvent()
		},
		startEvent() {
			if (this.step === '1') {
				// 서버로부터 받은 이벤트 시작/종료 날짜를 한국 시간으로 변환
				const startDate = this.$moment(this.eventsData.start).utcOffset('+09:00')
				const endDate = this.$moment(this.eventsData.end).utcOffset('+09:00')
				const currentDate = this.$moment().utcOffset('+09:00')
				// 현재 시간이 이벤트 기간 내인지 확인
				const isEventActive = currentDate.isSameOrAfter(startDate) && currentDate.isSameOrBefore(endDate)
				if (isEventActive) {
					this.eventJoinsConnection()
					this.step = '2'
				} else if (currentDate.isBefore(startDate)) {
					this.alertModal.text = '이벤트가 아직 시작되지 않았습니다.'
					return (this.alertModal.dialog = true)
				} else {
					this.alertModal.text = '이벤트가 종료되었습니다.'
					return (this.alertModal.dialog = true)
				}
			} else if (this.step === '2') {
				this.createEventJoin()
				// // this.messages()
				// this.createSendSm()
				// this.step = '3'
			} else if (this.step === '3') this.authCodecheck()
			else if (this.step === '4') {
				this.createEventJoin()
			}
		},
		onChange_kr() {
			this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
		},
		onKeyPress_kr(button) {
			if (button === '{retry}') {
				this.nametxtField.value = ''
				this.nameTxtArray = []
			} else {
				if (button !== '{bksp}') {
					this.nameTxtArray.push(button)
				} else {
					if (this.nameTxtArray.length > 0) {
						this.nameTxtArray.splice([this.nameTxtArray.length - 1], 1)
						this.nametxtField.value = Hangul.assemble(this.nameTxtArray)
					}
				}
			}
		},
		onChange_number(input) {
			if (input.length < 9) this.numtxtField.value = input
		},
		nameCrypto(name) {
			if (name.length === 1) {
				return name
			} else if (name.length === 2) {
				return name.slice(0, 1) + '*'
			} else {
				return name.slice(0, 1) + '*'.repeat(name.length - 2) + name.slice(-1)
			}
		},
		print_test() {
			var initBody
			window.onbeforeprint = () => {
				initBody = document.body.innerHTML
				document.getElementById('back-setting').style.backgroundColor = 'black'
				document.body.innerHTML = document.getElementById('print').innerHTML
			}
			window.onafterprint = () => {
				document.getElementById('back-setting').style.backgroundColor = 'white'
				document.body.innerHTML = initBody
			}
			window.print()
			return false
		},
		cancel() {
			this.nameTxtArray = []
			this.keypadInput = false
			this.agree = false
			this.nametxtField.value = ''
			this.numSel.value = '010'
			this.numtxtField.value = ''
		},
		terms(id) {
			const data = {
				stat: 1,
				id: id,
			}
			this.$store.dispatch('terms', data).then(res => {
				if (res.data.terms.length > 0) {
					this.agreeContent = res.data.terms[0].content
				}
			})
		},

		imgError() {
			this.eventsData.eventImg = null
		},
		getLength() {
			let index = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 90)
			if (index !== -1) {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length - 1
				this.$store.state.reservedayInputBox.categories.splice(index, 1)
			} else {
				this.surveyLegnth = this.$store.state.reservedayInputBox.categories.length
			}
			let dateIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 30)
			if (dateIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(dateIndex, 1)
				this.surveyLegnth--
			}
			let timeIndex = this.$store.state.reservedayInputBox.categories.findIndex(e => e.type === 31)
			if (timeIndex !== -1) {
				this.$store.state.reservedayInputBox.categories.splice(timeIndex, 1)
				this.surveyLegnth--
			}
		},
		createTrackingCode() {
			const data = {
				name: this.startDialog.nametxtField.value,
				phone: this.startDialog.numSel.value + this.startDialog.numtxtField.value,
			}
			this.$store
				.dispatch('createTrackingCode', data)
				.then(res => {
					this.$store.state.trackingCodeId = res.data.createTrackingCode.trackingCode.id
					if (!this.eventsData.population || this.eventsData.population === '설정 해제') {
						if (this.eventsData.accessPhones !== '' && this.Data.accessPhones !== null) {
							this.checkPhone()
						} else {
							this.reserveusers()
						}
					} else {
						this.checkPopulation()
					}
				})
				.catch(() => {})
		},

		disableNext() {},
		clickdoneBtn() {
			this.reserveDialog.dialog = false
		},
		checkPhone() {
			let phone = this.startDialog.numSel.value + this.startDialog.numtxtField.value
			let realPhone = phone
				.replace(/[^0-9]/g, '')
				.replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3')
				.replace('--', '-')
			let nameCheck = this.eventsData.accessPhones
				.filter(x => x.name === this.startDialog.nametxtField.value)
				.map(x => x.phone)
				.indexOf(realPhone)
			if (nameCheck !== -1) {
				this.reserveusers()
			} else {
				this.alertModal.text = '해당 서비스의 참여 대상이 아닙니다.'
				this.alertModal.dialog = true
				this.startDialog.dialog = false
			}
		},
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		closePage() {
			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		randomItem(item) {
			return item[Math.floor(Math.random() * item.length)]
		},
		shuffle(array) {
			return array.sort(() => Math.random() - 0.5)
		},
		imageUrl(data) {
			if (data === '골프공') return require('@/assets/images/1_hills.jpg')
			else if (data === '볼라이너') return require('@/assets/images/2_hills.jpg')
			else if (data === '릴타월') return require('@/assets/images/3_hills.jpg')
			else if (data === '골프티') return require('@/assets/images/4_hills.jpg')
			else if (data === '생수500ml') return require('@/assets/images/5_hills.jpg')
			else if (data === '물티슈') return require('@/assets/images/6_hills.jpg')
			else if (data === '그린피50%') return require('@/assets/images/7_hills.jpg')
			else if (data === '2만원할인권') return require('@/assets/images/8_hills.jpg')
			else if (data === '1만원할인권') return require('@/assets/images/9_hills.jpg')
		},
		// 생성 / 수정시 알림톡
		creaetSendMessage() {
			// const today = this.$moment(now).format('YYYY년 MM월 DD일 HH:mm')
			var randomCode = Math.floor(Math.random() * 1000000) + 100000
			if (randomCode > 1000000) {
				randomCode = randomCode - 100000
			}
			if (this.messageData1.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData1.message = this.messageData1.message.replace(/#{사업지명}/g, '서수원 에피트')
				this.messageData1.message = this.messageData1.message.replace(/#{인증번호}/g, randomCode)
			}
			const data = {
				// 필수값
				code: this.code,
				sender: this.messageData1.smssender,
				senderkey: this.messageData1.senderkey,
				tpl_code: this.messageData1.tplCode,
				receiver_1: this.numSel.value + this.numtxtField.value,
				subject_1: this.messageData1.tplCodeStr,
				message_1: this.messageData1.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.nametxtField.value,
				failover: 'Y',
				fsubject_1: this.messageData1.tplCodeStr,
				fmessage_1: this.messageData1.message,
				button_1: this.messageData1.button ? this.messageData1.button : '[]',
				pay: this.eventsData.business?.id,
				authCode: String(randomCode),
			}
			this.$store
				.dispatch('createSendMessage', data)
				.then(() => {})
				.catch(err => {
					console.log(err)
				})
		},
		// 내가받을 알림톡 알림톡
		messages() {
			const data = {
				tplCode: 'UA_7425',
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					this.messageData1 = res.data.messages[0] // create / update 알림톡 데이터
					this.creaetSendMessage()
				})
				.catch(() => {})
		},

		closeLucky() {
			this.$store.state.loading = false
			this.lucky = false
			this.step = '1'
			this.nametxtField.value = ''
			this.numtxtField.value = ''
			this.numSel.value = '010'
			this.personalInfoConsent = 'agree'
			this.marketingConsent = 'agree'
			this.waiting_agree = 'agree'
		},

		spinRoullet() {
			this.roulletDialog = true

			let roullet_board = this.$refs.roullet_board

			roullet_board.style.transform = `rotate(15deg)`
			roullet_board.style.transition = `initial`

			const ready_second = 250
			const spin_second = 3000
			const close_second = 250
			const spin_number = 10

			const product_total = 9
			const ran = Math.floor(this.winnerRoulletIndex() * product_total)

			const arc = 360 / product_total
			setTimeout(() => {
				// 당첨 칸의 중앙이 상단 포인터에 오도록 회전 (한 칸 = arc°)
				const rotate = ran * arc - this.winnerRoulletIndex() * arc + 360 * spin_number - arc + arc / 2

				roullet_board.style.transform = `rotate(${rotate}deg)`
				roullet_board.style.transition = `${spin_second}ms cubic-bezier(0,0,0,.98)`

				var audio = new Audio('/roulette sound.mp3')
				audio.load()
				audio.volume = 1
				audio.play()
			}, ready_second)

			// 폭죽 효과
			setTimeout(() => {
				this.firework()
			}, spin_second + ready_second)

			// 룰렛 완료 후 룰렛 닫기
			setTimeout(() => {
				this.roulletDialog = false
				this.lucky = true
			}, spin_second + ready_second + close_second)
		},

		winnerRoulletIndex() {
			// hills_roullet2.png 기준: 상단 포인터에서 시계방향 순서 (9칸 × 40°)
			if (this.winnterProduct === '2만원할인권') return 0
			else if (this.winnterProduct === '1만원할인권') return 1
			else if (this.winnterProduct === '골프공') return 2
			else if (this.winnterProduct === '볼라이너') return 3
			else if (this.winnterProduct === '릴타월') return 4
			else if (this.winnterProduct === '골프티') return 5
			else if (this.winnterProduct === '생수500ml') return 6
			else if (this.winnterProduct === '물티슈') return 7
			else if (this.winnterProduct === '그린피50%') return 8
		},

		/**** 폭죽놀이
			 @author 전현균
		 */
		firework() {
			const defaults = { startVelocity: 25, spread: 360, ticks: 50, zIndex: 9998 }
			function randomInRange(min, max) {
				return Math.random() * (max - min) + min
			}
			const particleCount = 50 // 줄임
			let count = 0
			let interval = setInterval(() => {
				if (count > 1) {
					// 반복 2회만
					clearInterval(interval)
				}
				count++
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.2, 0.4), y: Math.random() - 0.2 },
					}),
				)
				window.confetti(
					Object.assign({}, defaults, {
						particleCount,
						origin: { x: randomInRange(0.6, 0.8), y: Math.random() - 0.2 },
					}),
				)
			}, 400) // 간격도 약간 늘림
		},

		/**** 무기명 참여
 * name : 무기명, phone : 00000000000 으로 데이터 고정
 * 나머지는 로직은 동일
	 @author 전현균
 */
		noPhoneStart() {
			let data2 = {
				name: '무기명',
				phone: '00000000000',
				code: this.code,
			}
			if (this.eventsData.input_box !== null) {
				data2['inputBoxId'] = this.eventsData.input_box.id
			}

			this.$store.dispatch('createEventJoin', data2).then(res => {
				if (res.data.createEventJoin.eventJoin.name === '이벤트 종료') {
					this.alertModal2.text = '본 이벤트의 모든 참여가 완료되었습니다.'
					this.alertModal2.dialog = true
				} else if (res.data.createEventJoin.eventJoin.name === '중복번호') {
					this.alertModal2.text = '본 이벤트는 중복 참여가 불가능합니다.'
					this.alertModal2.dialog = true
				} else {
					this.winnterProduct = res.data.createEventJoin.eventJoin.winnterProduct
					this.luckyImage = this.imageUrl(res.data.createEventJoin.eventJoin.winnterProduct)
					this.spinRoullet()
				}
				this.$store.state.loading = false
			})
		},
	},
}
</script>

<style lang="scss">
@page {
	size: auto; /* auto is the initial value */
	margin: 5mm; /* this affects the margin in the printer settings */
}

#print-background {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print {
	display: none;
}
.check_re_btn {
	width: 200px !important;
	height: 45px !important;
}
.check_complete {
	width: 200px !important;
	height: 45px !important;
}
.infoBackground {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 90px;
	min-height: 90px;
	margin-bottom: 10px;
	.infoYear {
		background-color: white;
		color: black;
		font-size: 14px;
		border-radius: 10px 10px 0px 0px;
	}
	.infoHour {
		font-size: 14px;
		font-weight: 100;
	}
}
.check_dialog_tablet {
	width: fit-content !important;
	max-width: 90vw !important;
	max-height: 95vh;
	overflow: auto;
	margin: 0 auto;
	padding: 20px;
	background-color: #ececec;
}
.check_dialog_tablet .lucky-image {
	max-height: 80vh;
	width: auto;
	display: block;
	margin: 0 auto;
}
.check_dialog {
	padding: 20px;
	background-color: #ececec;
	.check_layout {
		background-color: white;
		border-radius: 10px;
		padding: 20px;
		.check_sub_layout {
			padding-left: 100px;
		}
		.check_title {
			text-align: center;
			font-size: 47px;
			font-weight: bold;
			color: #631115;
		}
		.check_sub_title {
			font-size: 18px;
			font-weight: bold;
			color: #631115;
		}
		.check_info {
			font-size: 17px;
			padding-left: 35px;
			color: #707070;
		}
	}
}
.radio_label_white {
	label {
		color: white !important;
	}
}
.keypad_btn {
	width: 230px;
	height: 69px !important;
	background-color: white !important;
	font-weight: bold !important;
	border-radius: 15px !important;
	font-size: 26px !important;
}
.keypad_background {
	background-color: rgba(255, 255, 255, 0.43);
	border-radius: 18px;
	padding: 8px;
}

.placeholder-color-white {
	.v-input__control {
		.v-input__slot {
			.v-text-field__slot {
				input {
					font-size: 36px !important;
				}
			}
		}
	}
}
.keypad_agree_content {
	border: 1px solid;
	border-color: rgba(255, 255, 255, 0.5);
	border-radius: 15px;
	white-space: break-spaces;
	color: white;
	font-size: 11px;
	padding: 8px;
	text-align: left;
	height: auto;
	max-height: 276px;
	overflow: auto;
}
.reserve_keypad_maintxt {
	font-size: 24px;
	font-weight: bold;
	color: white;
}
.reserve_keypad_subtxt {
	font-size: 20px;
	color: white;
}
.reserve-background-width {
	width: 1440px;
	min-width: 1440px;
	max-width: 1440px;
	height: 2503px;
	min-height: 2503px;
	max-height: 2503px;
	margin: 0 auto;
}

.startVisit {
	background: white !important;
	padding: 20px 0px;
}
.cardTitle {
	font-size: 18px;
	font-weight: bold;
	text-align: center;
}
.guide {
	font-size: 13px;
	font-weight: bold;
	color: #606060;
}
.dialogBottom {
	.title {
		height: 50px;
		display: flex;
		align-items: center;
		text-align: center;
		background-color: #fdc85a;
		padding: 0 10px 0 30px;

		h2 {
			color: white;
			font-weight: bold;
			font-size: 18px;
		}

		.title-icon {
			color: white;
		}
	}
	.dialog-content {
		padding: 20px 20px 20px 20px;
	}
}
.hiddenTab {
	display: none;
}

.roullet_dialog.v-dialog {
	overflow: hidden;
	background: transparent;
	box-shadow: none;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}
.selectNum .v-select__selection {
	height: 27px !important;
	font-size: 36px !important;
}
.selectNum .v-input__control {
	min-height: 80px !important;
}
</style>
<style lang="scss" scoped>
.nextButton_css {
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
	background: linear-gradient(90deg, #3f3536 0%, #3f3536 100%);
	color: white;
	border: none;
	border-radius: 80px !important;
	padding: 0 60px !important;
	height: 110px !important;
	font-size: 64px !important;
	font-weight: bold;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 500px !important;
	justify-content: center;
	.text {
		margin-right: 10px;
	}
	.arrow {
		font-size: 120px;
		margin-bottom: 28px;
		font-weight: 100;
	}
}
.imageButton {
	width: 1440px;
	height: 2304px;
	.v-responsive__content {
		background-size: contain;
		position: relative;
		.keypad_main_layout {
			padding: 0 28px;
			position: absolute;
			top: 350px;
		}
		.clickBtn {
			position: absolute;
			bottom: 980px;
			width: 100%;
			button {
				height: 120px;
				font-size: 48px;
				font-weight: bold;
				margin: 0 auto;
				min-width: 100px;
				width: 100%;
				max-width: 710px;
				border-radius: 15px;
			}
		}
	}
	text-align: end;
	padding: 20px;
}
.reserveInfo {
	font-size: 14px;
	font-weight: bold;
	padding: 16px 16px 0px;
	color: #808080;
}
.duplicateInfo {
	font-size: 15px;
	margin-left: 16px;
	color: #808080;
}
.roullet_div {
	width: 1200px;
	padding-top: 80px;
	position: relative;
}
.roullet_board {
	transform: rotate(15deg);
	width: 100%;
}
.roullet_arrow {
	width: 125px;
	z-index: 1;
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0%);
	top: -10px;
}
#print-background-cobe {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
#print-background-cobe2 {
	padding: 0 16px;
	max-width: 298.6px;
	width: 100vh;
	height: 100vh;
	background-color: white;
	display: none;
}
.event-bottom-img {
	position: absolute;
	bottom: 120px;
}
.next-button-container {
	overflow: hidden;
	display: flex;
	justify-content: center;
	margin: 30px;
}
.reserve-background-width {
	height: 100vh;
	width: 100%;
	min-width: 1440px;
	max-width: 1440px;
	margin: 0 auto;
}
/* step1 */
.content_step1 {
	background-color: #3f3536;
	color: white;
	padding: 160px 40px 0px 40px;
	text-align: center;
}

.title-small {
	font-size: 36px;
	margin-bottom: 12px;
}

.title-large {
	font-size: 76px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.2;
}

.divider {
	width: 1px;
	height: 60px;
	background-color: #fff;
	margin: 80px auto;
}

.event-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
}
.event-bottom {
	margin: 0 150px;
}
.event-subtitle {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 80px;
	line-height: 1.3;
}

.start-button {
	display: inline-block;
	background-color: white;
	color: #3f3536;
	padding: 4px 0px;
	width: 350px;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	margin-bottom: 80px;
}

.start-button:hover {
	background-color: #f0f0f0;
}

.prizes-container {
	background-color: white;
	border-radius: 30px;
	padding: 40px;
	margin-bottom: 20px;
	display: flex;
	flex-wrap: wrap;
}

.prize-item {
	width: 50%;
	padding: 20px;
	text-align: center;
}

.prize-rank {
	display: block;
	margin-bottom: 20px;
	width: 120px;
	height: 120px;
}

.prize-image {
	width: 160px;
	height: 160px;
	margin: 0 auto 20px;
}

.prize-name {
	color: #3f3536;
	font-weight: bold;
	font-size: 32px;
	margin-bottom: 5px;
}

.prize-desc {
	color: #666;
	font-size: 28px;
}

.footnotes {
	text-align: left;
	color: #aaa;
	font-size: 16px;
	line-height: 1.5;
	white-space: pre-line;
}

/* step2 */
.content_step2 {
	height: auto;
	overflow: hidden;
	padding: 80px 10px 0px 10px;
	color: #3f3536;
}
.info-section {
	padding: 0px 80px 0px 80px;
}

.info-header {
	color: black;
	letter-spacing: -4px;
	font-size: 64px;
	font-weight: bold;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 30px;
	text-align: center;
}

.info-form {
	padding: 20px;
	border-radius: 16px;
	background-color: #3f3536;
}

.form-group {
	margin-bottom: 20px;
}

.form-input-direct {
	width: 100%;
	height: 80px;
	padding: 10px 20px;
	font-size: 36px;
	border: none;
	border-radius: 8px;
	background-color: white;
	color: black;
	outline: none;
}

.form-input-direct::placeholder {
	color: #999;
	font-size: 30px;
}

.form-label {
	color: white;
	display: block;
	font-size: 48px;
	width: 250px;
	min-width: 250px;
}

.form-input {
	width: 100%;
	height: 100px;
	padding: 10px 20px;
	font-size: 42px;
	border: 1px solid #ccc;
	background-color: white;
	color: black;
}

.info-desc {
	padding: 0px 40px 0px 40px;
	font-size: 36px;
	line-height: 1.6;
	color: #e0e0e0;
}

.info-desc-title {
	margin-top: 30px;
	color: #3f3536;
	font-size: 36px;
	font-weight: 700;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}

.info-desc-title::before {
	content: '■';
	margin-right: 10px;
}

.info-content {
	color: black;
	margin-bottom: 25px;
	line-height: 1.4;
	font-size: 24px;
}
.info-text {
	text-align: center;
	font-weight: bold;
	font-size: 18px;
	line-height: 1.4;
	color: black;
	margin-bottom: 4px;
}
.info-table {
	width: 100%;
	border-collapse: collapse;
	color: #3f3536;
	background-color: #efefef;
}

.info-table th,
.info-table td {
	padding: 8px;
	text-align: left;
	border: 1px solid #ddd;
	font-size: 20px;
	letter-spacing: -1px;
	background-color: white;
	color: black;
	white-space: pre-line;
}

.info-table th {
	background-color: #e0e0e0;
	width: 25%;
	text-align: center;
}

.next-button {
	display: block;
	width: 350px;
	height: 80px;
	background-color: #3f3536;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 80px;
	text-decoration: none;
}

/* step3 */
.content_step3 {
	height: 88vh;
	overflow: hidden;
	padding: 80px 300px 0 300px;
	color: #3f3536;
}
.auth-header {
	.bold {
		font-weight: bold;
	}
	background-color: #e9eae4;
	border-radius: 16px;
	padding: 24px 48px 24px 48px;
	width: 100%;
	text-align: center;
	margin-bottom: 50px;
}

.auth-header h1 {
	font-size: 80px;
	font-weight: bold;
	color: #3f3536;
	margin-bottom: 25px;
}

.auth-header p {
	font-size: 42px;
	color: black;
	line-height: 1.5;
	margin-bottom: 0px !important;
}

.auth-form {
	background-color: #3f3536;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px;
}

.auth-input-container {
	padding: 0 26px;
	width: 100%;
}

#auth-input {
	width: 100%;
	height: 140px;
	background-color: #dcdedd;
	border: 1px solid #ccc;
	font-size: 64px;
	text-align: center;
	letter-spacing: 10px;
	outline: none;
	cursor: default;
	color: black;
}

.keypad {
	width: 100%;
	background-color: #3f3536;
	border-radius: 10px;
	padding: 20px;
}

.keypad-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
}

.keypad-row:last-child {
	margin-bottom: 0;
}

.key {
	flex: 1;
	height: 120px;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: white;
	color: #000;
	border: #000 1px solid;
	font-size: 80px;
	font-weight: bold;
	margin: 0 8px;
	cursor: pointer;
	user-select: none;
	text-align: center;
}

.clear-key {
	font-size: 48px;
	line-height: 1.2;
}

.backspace-key {
	font-size: 64px;
}

.key:active {
	background-color: #999999;
}

.action-button-container {
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 40px auto;
}
.action-button-outlined {
	width: 500px;
	height: 110px;
	background-color: white;
	color: #3f3536;
	border: border 1px solid #3f3536;
	border-radius: 80px;
	font-size: 64px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 110px;
	text-decoration: none;
}
.action-button {
	width: 500px;
	height: 110px;
	background-color: #3f3536;
	color: white;
	border: none;
	border-radius: 60px;
	font-size: 56px;
	font-weight: bold;
	cursor: pointer;
	text-align: center;
	line-height: 110px;
	text-decoration: none;
}

.action-button:hover {
	background-color: #3f3536;
}

/* step4 */
.title-container {
	text-align: center;
}

.main-title {
	font-size: 100px;
	font-weight: bold;
	line-height: 1.2;
	letter-spacing: -1px;
}

.sub-title {
	font-size: 100px;
	font-weight: bold;
	margin-bottom: 100px;
}

.schedule-table {
	width: 100%;
	max-width: 850px;
	margin: 0 auto;
	margin-bottom: 100px;
}

.schedule-table th,
.schedule-table td {
	text-align: center;
	vertical-align: middle;
	height: 140px;
	font-size: 50px;
	font-weight: bold;
}

.schedule-table th {
	background-color: #d5d5d5;
	color: #3f3536;
}

.schedule-table td {
	background-color: white;
	color: #3f3536;
}

.date {
	font-size: 60px;
}

.day {
	font-size: 40px;
	display: block;
	margin-bottom: 16px;
}

.button-container {
	margin: 100px 0;
}

.reservation-button {
	background-color: white;
	color: #3f3536;
	padding: 4px 0;
	width: 400px;
	border-radius: 60px;
	font-size: 48px;
	font-weight: bold;
	cursor: pointer;
}
.divider-width {
	margin: 0 auto;
	max-width: 850px;
	width: 100%;
	height: 1px;
	background-color: #fff;
}
.info-block {
	width: 100%;
	max-width: 850px;
	background-color: #d5d5d5;
	color: #3f3536;
	padding: 8px 0;
	text-align: center;
	font-size: 48px;
	font-weight: bold;
	margin: 0 auto;
}

.house-info {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	font-size: 57px;
}

.house-separator {
	margin: 0;
}

.contact-number {
	font-size: 120px;
	font-weight: bold;
	margin-bottom: 160px;
}

/* 동의서 스타일 */
.consent-container {
	background-color: transparent;
	padding: 0;
	margin-top: 20px;
}

.consent-title {
	font-size: 32px;
	font-weight: bold;
	color: #000;
	margin-bottom: 4px;
}

.consent-desc {
	font-size: 24px;
	line-height: 1.6;
	margin-bottom: 16px;
	color: #000;
}

.consent-desc p {
	margin: 4px 0;
}

.consent-info-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 15px;
	font-size: 14px;
}

.consent-info-table .th-dark {
	background-color: #3f3536;
	color: white;
	padding: 0px 10px;
	text-align: center;
	border: 1px solid #3f3536;
	font-weight: bold;
}

.consent-info-table .td-label {
	background-color: #d9d9d9;
	padding: 10px;
	text-align: center;
	border: 1px solid #999;
	font-weight: bold;
	color: #000;
	font-size: 24px;
}

.consent-info-table .td-content {
	font-size: 24px;
	background-color: #f5f5f5;
	padding: 0px 10px;
	border: 1px solid #999;
	text-align: left;
	line-height: 1.5;
	color: #000;
}

.consent-agree-table {
	width: 100%;
	border-collapse: collapse;
	font-size: 14px;
}

.consent-agree-table .agree-question {
	font-size: 24px;
	padding: 8px 16px;
	text-align: right;
	color: #000;
	font-weight: 500;
	border: none;
}

.consent-agree-table .agree-option {
	padding: 8px 10px;
	text-align: center;
	border: none;
}

.consent-agree-table .radio-label {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	cursor: pointer;
	font-size: 24px;
	color: #000;
	font-weight: 500;
}

.consent-agree-table .radio-label input[type='radio'] {
	width: 22px;
	height: 22px;
	cursor: pointer;
}
</style>
